(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hb-scroll-light')){
 customElements.define('hb-scroll-light',class extends HTMLElement{
  connectedCallback(){
   if(!this.hasAttribute('data-enabled'))return;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.media=this.querySelector('.hb-hero-media');
   this.off=this.querySelector('.hb-light-off img');
   if(!this.media||!this.off)return;
   this.scroller=window;
   for(let ancestor=this.parentElement;ancestor;ancestor=ancestor.parentElement){
    if(/auto|scroll/.test(getComputedStyle(ancestor).overflowY)&&ancestor.scrollHeight>ancestor.clientHeight){this.scroller=ancestor;break;}
   }
   this.frame=0;
   this.update=()=>{
    this.frame=0;
    if(this.motion.matches){this.style.setProperty('--hb-light','1');return;}
    const y=this.scroller===window?scrollY:this.scroller.scrollTop;
    const height=this.scroller===window?innerHeight:this.scroller.clientHeight;
    const origin=this.scroller===window?0:this.scroller.getBoundingClientRect().top;
    const top=this.getBoundingClientRect().top-origin+y;
    const imageTop=this.media.getBoundingClientRect().top-origin+y;
    const start=Math.max(0,imageTop-height*.85)+2;
    const distance=Math.max(24,Math.min(64,this.media.getBoundingClientRect().height*.12));
    const p=Math.max(0,Math.min(1,(y-start)/distance));
    this.style.setProperty('--hb-light',(p*p*(3-2*p)).toFixed(4));
    this.dataset.progress=p.toFixed(3);
   };
   this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
   this.ready=()=>{if(!this.isConnected||!this.off.naturalWidth)return;this.setAttribute('data-ready','');this.update();};
   this.failed=()=>{this.removeAttribute('data-ready');this.style.setProperty('--hb-light','1');};
   this.off.addEventListener('load',this.ready);
   this.off.addEventListener('error',this.failed);
   this.scroller.addEventListener('scroll',this.schedule,{passive:true});
   addEventListener('resize',this.schedule,{passive:true});
   addEventListener('pageshow',this.schedule);
   this.motion.addEventListener('change',this.schedule);
   if(this.off.complete)this.ready();
  }
  disconnectedCallback(){
   if(this.frame)cancelAnimationFrame(this.frame);
   if(this.schedule){this.scroller?.removeEventListener('scroll',this.schedule);removeEventListener('resize',this.schedule);removeEventListener('pageshow',this.schedule);this.motion?.removeEventListener('change',this.schedule);}
   this.off?.removeEventListener('load',this.ready);this.off?.removeEventListener('error',this.failed);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-review-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hb-review-carousel')){
 class HilaliReviewCarousel extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.track=this.querySelector('.hb-review-track');this.cards=[...this.querySelectorAll('.hb-review-card')];if(!this.cards.length)return;
   this.spacer=document.createElement('div');this.spacer.setAttribute('aria-hidden','true');this.spacer.style.flexShrink='0';this.track.append(this.spacer);this.resizeObserver=new ResizeObserver(()=>{this.spacer.style.width=Math.max(0,this.track.clientWidth-this.cards[0].getBoundingClientRect().width-parseFloat(getComputedStyle(this.track).gap||20)-4)+'px';});this.resizeObserver.observe(this.track);
   this.active=0;this.visible=false;this.sound=false;this.hover=false;this.focus=false;this.drag=false;
   this.auto=this.dataset.auto==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&!window.Shopify?.designMode;
   
   this.listen=(el,event,fn)=>el.addEventListener(event,fn,{signal});
   this.clear=()=>{clearTimeout(this.timer);this.timer=null;};
   this.allowed=()=>this.auto&&this.visible&&!document.hidden&&!this.hover&&!this.focus&&!this.drag&&!this.dialog.open&&!this.cards[this.active].querySelector('details[open]');
   this.schedule=()=>{
    this.clear();if(!this.allowed())return;const video=this.cards[this.active].querySelector('video');if(video){if(video.ended)this.timer=setTimeout(()=>{if(this.allowed())this.go(1);},1000);return;}
    const words=(this.cards[this.active].querySelector('blockquote')?.textContent||'').trim().split(/\s+/).length;
    this.timer=setTimeout(()=>{if(this.allowed())this.go(1);},Math.max(Number(this.dataset.delay)||12000,words*400+4000));
   };
   this.play=()=>{
    const video=this.cards[this.active].querySelector('video');if(!video||!this.visible||document.hidden||this.dialog.open)return;
    video.muted=!this.sound;
    if(video.ended)video.currentTime=0;
    const index=this.active;
    video.play().catch(()=>{if(index!==this.active||!this.visible)return;video.muted=true;this.sound=false;video.play().catch(()=>{});});
   };
   this.go=step=>{
    this.clear();const next=(this.active+step+this.cards.length)%this.cards.length;
    const rect=this.cards[next].getBoundingClientRect(),base=this.track.getBoundingClientRect();
    const rtl=getComputedStyle(this.track).direction==='rtl';
    const offset=rtl?rect.right-base.right:rect.left-base.left;
    this.track.scrollBy({left:offset,behavior:Math.abs(next-this.active)>1||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   };
   this.settle=()=>{
    const base=this.track.getBoundingClientRect();const rtl=getComputedStyle(this.track).direction==='rtl';
    let best=Infinity,next=0;this.cards.forEach((card,i)=>{const r=card.getBoundingClientRect(),distance=Math.abs(rtl?r.right-base.right:r.left-base.left);if(distance<best){best=distance;next=i;}});
    if(next!==this.active){this.cards[this.active].querySelector('video')?.pause();this.active=next;this.play();}
    this.querySelector('.hb-review-position').textContent=(this.active+1)+' / '+this.cards.length;this.schedule();
   };
   this.listen(this.track,'scroll',()=>{this.clear();clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(this.settle,180);});
   this.listen(this.track,'pointerdown',()=>{this.drag=true;this.clear();});
   this.listen(window,'pointerup',()=>{this.drag=false;this.schedule();});
   this.listen(window,'pointercancel',()=>{this.drag=false;this.schedule();});
   this.listen(this.track,'mouseenter',()=>{this.hover=true;this.clear();});this.listen(this.track,'mouseleave',()=>{this.hover=false;this.schedule();});
   this.listen(this.track,'focusin',()=>{this.focus=true;this.clear();});this.listen(this.track,'focusout',()=>{queueMicrotask(()=>{this.focus=this.track.contains(document.activeElement);this.schedule();});});
   this.listen(this.track,'keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go((e.key==='ArrowRight'?1:-1)*(getComputedStyle(this.track).direction==='rtl'?-1:1));}});
   this.listen(this.querySelector('[data-back]'),'click',()=>this.go(-1));this.listen(this.querySelector('[data-next]'),'click',()=>this.go(1));
   this.dialog=this.querySelector('dialog');
   this.querySelectorAll('[data-full]').forEach(button=>this.listen(button,'click',()=>{this.clear();this.cards[this.active].querySelector('video')?.pause();this.dialog.querySelector('img').src=button.dataset.full;this.dialog.showModal();}));
   this.listen(this.dialog.querySelector('button'),'click',()=>this.dialog.close());this.listen(this.dialog,'click',e=>{if(e.target===this.dialog)this.dialog.close();});
   this.listen(this.dialog,'close',()=>{this.play();this.schedule();});
   this.cards.forEach((card,i)=>{
    const details=card.querySelector('details');if(details)this.listen(details,'toggle',this.schedule);
    const video=card.querySelector('video');if(!video)return;
    this.listen(video,'play',()=>{this.clear();this.cards.forEach((other,j)=>{if(j!==i)other.querySelector('video')?.pause();});});
    this.listen(video,'ended',()=>{if(i===this.active&&this.allowed())this.go(1);});
   });
   this.listen(document,'visibilitychange',()=>{this.clear();if(document.hidden)this.cards[this.active].querySelector('video')?.pause();else{this.play();this.schedule();}});
   this.visibilityObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.clear();if(this.visible){this.play();this.schedule();}else this.cards.forEach(card=>card.querySelector('video')?.pause());},{threshold:.3});this.visibilityObserver.observe(this.track);
   this.settle();
  }
  disconnectedCallback(){this.abort?.abort();this.visibilityObserver?.disconnect();this.resizeObserver?.disconnect();this.spacer?.remove();clearTimeout(this.timer);clearTimeout(this.scrollTimer);this.cards?.forEach(card=>card.querySelector('video')?.pause());}
 }
 customElements.define('hb-review-carousel',HilaliReviewCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-room-edits"] && !Shopify.designMode) return;
  try {
    



if (!customElements.get('hb-room-rail')) {



 class HBRoomRail extends HTMLElement {



  connectedCallback() {



   this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;



   this.rail=this.querySelector('.hb-room__rail');if(!this.rail)return;



   this.originals=[...this.rail.children].filter(el=>!el.hasAttribute('data-rail-clone'));this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.mobile=matchMedia('(max-width:749px)');



   this.button=this.querySelector('[data-toggle]');this.paused=false;this.visible=false;this.touching=false;this.hovered=false;this.focused=false;



   this.prepare=()=>{



    this.querySelectorAll('[data-rail-clone]').forEach(el=>el.remove());this.period=0;



    if(this.originals.length<2 || this.reduced.matches || this.mobile.matches){this.rail.scrollLeft=0;return;}



    for(const side of ['before','after']){



     const fragment=document.createDocumentFragment();



     for(const card of this.originals){const clone=card.cloneNode(true);clone.dataset.railClone='';clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a,button').forEach(a=>a.tabIndex=-1);fragment.append(clone);}



     if(side==='before')this.rail.prepend(fragment);else this.rail.append(fragment);



    }



    this.measure();



   };



   this.measure=()=>{const first=this.originals[0];if(!first)return;const last=this.originals.at(-1);const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;this.period=this.rail.querySelector('[data-rail-clone]')?last.offsetLeft+last.offsetWidth-first.offsetLeft+gap:0;if(this.period)this.rail.scrollLeft=this.period;};



   this.normalize=()=>{if(!this.period || this.focused)return;const x=this.rail.scrollLeft;if(x<this.period*.5)this.rail.scrollLeft=x+this.period;else if(x>this.period*1.5)this.rail.scrollLeft=x-this.period;};



   this.tick=time=>{this.frame=0;const dt=Math.min(40,time-(this.last||time));this.last=time;



    if(!this.paused&&!this.touching&&!this.hovered&&!this.focused&&time>(this.restUntil||0)){

     this.position=(this.position??this.rail.scrollLeft)+dt*.018;

     this.rail.scrollLeft=this.position;

     const before=this.rail.scrollLeft;this.normalize();this.position+=this.rail.scrollLeft-before;

     this.rail.style.setProperty('--hb-drift',`${this.rail.scrollLeft-this.position}px`);

    }else{this.position=undefined;this.rail.style.setProperty('--hb-drift','0px');}



    if(this.visible&&!document.hidden&&!this.reduced.matches&&!this.mobile.matches&&this.dataset.auto==='true')this.frame=requestAnimationFrame(this.tick);



   };



   this.run=()=>{cancelAnimationFrame(this.frame);this.last=0;if(this.visible&&!document.hidden&&!this.reduced.matches&&!this.mobile.matches&&this.dataset.auto==='true')this.frame=requestAnimationFrame(this.tick);};



   this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true;},{signal});



   this.addEventListener('pointerleave',()=>{this.hovered=false;},{signal});



   this.addEventListener('pointerdown',()=>{this.touching=true;},{signal,passive:true});



   const release=()=>{this.touching=false;this.restUntil=performance.now()+1200;};



   window.addEventListener('pointerup',release,{signal,passive:true});window.addEventListener('pointercancel',release,{signal,passive:true});



   this.addEventListener('focusin',()=>{this.focused=true;},{signal});this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.focused=false;},{signal});



   this.rail.addEventListener('wheel',()=>{this.restUntil=performance.now()+2500;},{signal,passive:true});



   this.rail.addEventListener('scroll',this.normalize,{signal,passive:true});



   this.addEventListener('click',e=>{const button=e.target.closest('button');if(!button||!this.contains(button))return;



    if(button.hasAttribute('data-toggle')){this.paused=!this.paused;button.setAttribute('aria-pressed',String(this.paused));button.setAttribute('aria-label',this.paused?button.dataset.resume:button.dataset.pause);button.firstElementChild.textContent=this.paused?'▷':'Ⅱ';return;}



    if(button.dataset.step){const step=Number(button.dataset.step);const first=this.originals[0];const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;this.focused=false;this.rail.scrollLeft+=step*(first.offsetWidth+gap);this.normalize();this.focused=this.contains(document.activeElement);this.restUntil=performance.now()+3000;}



   },{signal});



   const modeChange=()=>{this.position=undefined;this.rail.style.setProperty('--hb-drift','0px');this.button.hidden=this.mobile.matches||this.dataset.auto!=='true';this.prepare();this.run();};this.reduced.addEventListener('change',modeChange,{signal});this.mobile.addEventListener('change',modeChange,{signal});



   document.addEventListener('visibilitychange',this.run,{signal});



   this.button.hidden=this.mobile.matches||this.dataset.auto!=='true';



   this.prepare();this.resize=new ResizeObserver(()=>this.measure());this.resize.observe(this.rail);



   this.intersection=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.run();},{threshold:.05});this.intersection.observe(this);



  }



  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.intersection?.disconnect();cancelAnimationFrame(this.frame);this.querySelectorAll('[data-rail-clone]').forEach(el=>el.remove());}



 }



 customElements.define('hb-room-rail',HBRoomRail);



}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-selection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-discover')) {
  class HBDiscover extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.track = this.querySelector('.hb-discover__track');
      if (!this.track) return;
      const signal = this.abort.signal;
      this.move = step => {
        const items = [...this.track.children];
        const box = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance=item=>Math.abs(rtl?item.getBoundingClientRect().right-box.right:item.getBoundingClientRect().left-box.left);
        const current = items.reduce((best,item,index) => distance(item) < best.distance ? {index,distance:distance(item)} : best,{index:0,distance:Infinity}).index;
        const target = items[Math.max(0,Math.min(items.length-1,current+step))];
        if (!target) return;
        const delta = rtl ? target.getBoundingClientRect().right-box.right : target.getBoundingClientRect().left-box.left;
        this.track.scrollBy({left:delta,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      };
      this.addEventListener('click',event => {const button=event.target.closest('button[data-step]');if(button && this.contains(button))this.move(Number(button.dataset.step));},{signal});
      this.track.addEventListener('keydown',event => {
        if(event.target!==this.track || !['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();
        const rtl=getComputedStyle(this.track).direction==='rtl';
        this.move((event.key==='ArrowRight'?1:-1)*(rtl?-1:1));
      },{signal});
      const update=()=>{
        const items=[...this.track.children];const box=this.track.getBoundingClientRect();const rtl=getComputedStyle(this.track).direction==='rtl';
        const near=(item)=>item && (rtl?item.getBoundingClientRect().right<=box.right+2:item.getBoundingClientRect().left>=box.left-2);
        this.querySelector('[data-step="-1"]').disabled=!items.length || near(items[0]);
        const last=items.at(-1);this.querySelector('[data-step="1"]').disabled=!last || (rtl?last.getBoundingClientRect().left>=box.left-2:last.getBoundingClientRect().right<=box.right+2);
      };
      this.track.addEventListener('scroll',update,{signal,passive:true});
      this.resize=new ResizeObserver(update);this.resize.observe(this.track);update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  }
  customElements.define('hb-discover',HBDiscover);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-service-ribbon"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hb-service-ribbon')){
  class HBServiceRibbon extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      const signal=this.abort.signal;
      const pause=()=>this.setAttribute('data-touching','');
      const resume=()=>this.removeAttribute('data-touching');
      this.addEventListener('touchstart',pause,{signal,passive:true});
      window.addEventListener('touchend',resume,{signal,passive:true});
      window.addEventListener('touchcancel',resume,{signal,passive:true});
      window.addEventListener('blur',resume,{signal});
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  customElements.define('hb-service-ribbon',HBServiceRibbon);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
